import { useEffect, useRef, useState } from 'react';

// Dictation through the browser's speech recognition, where it exists
// (Chrome, Edge, Safari). The mic starts only on an explicit tap — never on
// open — and typing always works. Final phrases are handed to onText; the
// interim phrase is shown while it is still being recognised.
export default function useSpeech({ onText }) {
  const Recognition = typeof window !== 'undefined' ? (window.SpeechRecognition || window.webkitSpeechRecognition) : null;
  const supported = !!Recognition;
  const [listening, setListening] = useState(false);
  const [interim, setInterim] = useState('');
  const recRef = useRef(null);
  const onTextRef = useRef(onText);
  onTextRef.current = onText;

  const start = () => {
    if (!supported || listening) return;
    const rec = new Recognition();
    rec.continuous = true;
    rec.interimResults = true;
    rec.lang = (typeof navigator !== 'undefined' && navigator.language) || 'en-US';
    rec.onresult = (event) => {
      let finals = '';
      let partial = '';
      for (let i = event.resultIndex; i < event.results.length; i += 1) {
        const result = event.results[i];
        if (result.isFinal) finals += result[0].transcript;
        else partial += result[0].transcript;
      }
      if (finals.trim()) onTextRef.current(finals.trim());
      setInterim(partial);
    };
    rec.onend = () => { setListening(false); setInterim(''); recRef.current = null; };
    rec.onerror = () => { setListening(false); setInterim(''); };
    recRef.current = rec;
    rec.start();
    setListening(true);
  };

  const stop = () => {
    if (recRef.current) recRef.current.stop();
  };

  useEffect(() => () => {
    if (recRef.current && typeof recRef.current.abort === 'function') recRef.current.abort();
  }, []);

  return { supported, listening, interim, start, stop };
}
